export const GetAllTxn = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    var data = []
    var isSuccess = false
    let requestOptions = {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        redirect: "follow",
    };

    await fetch(`${ApiURL}common/select/All/TXN`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, isSuccess }
}


export const getProductDetails = async (id) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var isSuccess = false
    var requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify({
            product: id
        }),
        redirect: "follow"
    }
    await fetch(`${ApiURL}Product/getProductDesc`, requestOptions)
        .then((response) => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, isSuccess }
}


export const getSupplierDetails = async (id) => {

    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var isSuccess = false
    var requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
    }
    await fetch(`${ApiURL}Supplier/search/${id}`, requestOptions)
        .then((response) => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, isSuccess }
}


export const getCustomerDetails = async (id) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var isSuccess = false
    var requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
    }
    await fetch(`${ApiURL}Customer/search/${id}`, requestOptions)
        .then((response) => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, isSuccess }
}


export const getGenSearchHeader = async (dataObject) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var isSuccess = false
    var requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
        body: JSON.stringify(dataObject)
    }
    await fetch(`${ApiURL}common/genSearch`, requestOptions)
        .then((response) => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, isSuccess }
}


export const getReportData = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var groupData = []
    var isSuccess = false
    var requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
    }
    await fetch(`${ApiURL}common/select/report`, requestOptions)
        .then((response) => response.json())
        .then(result => {
            if (result.success) {
                data = JSON.parse(result.data)
                groupData = JSON.parse(result.groupData)
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, groupData, isSuccess }
}



export const TestApi = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var groupData = []
    var isSuccess = false
    var requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
    }
    await fetch(`${ApiURL}myReport/report/generation`, requestOptions)
        .then((response) => response.json())
        .then(result => {
            if (result.success) {
                data = JSON.parse(result.data)
                groupData = JSON.parse(result.groupData)
                isSuccess = true
            }
        })
        .catch(error => console.log("error", error))
    return { data, groupData, isSuccess }
}
